import React from 'react';
import { DestinationIntel } from '../../types';
import { Clock } from 'lucide-react';
import { UnsplashCredit } from '../common/UnsplashCredit';
import './TimingSignalStrip.css';

interface TimingSignalStripProps {
  items: DestinationIntel[];
  label: string;
  /**
   * The whole row, not its name. The name alone is what forced every caller to
   * guess which destination was meant; the row carries `slug` when the atlas
   * knows it.
   */
  onDestinationClick?: (item: DestinationIntel) => void;
}

const TimingSignalStrip: React.FC<TimingSignalStripProps> = ({ items, label, onDestinationClick }) => {
  if (items.length === 0) return null;

  return (
    <div className="timing-signal-strip">
      <h3 className="timing-signal-label">{label}</h3>
      <div className="timing-signal-scroll">
        {items.map(item => (
          /* The credit sits OUTSIDE the card button, beside the photograph
             it credits (r774 finding 2). The serializer has always sent
             `hero_attribution` beside `hero_image_url`; this strip rendered
             the photograph and dropped the name. */
          <div key={item.id} className="timing-signal-frame">
          <button
            className="timing-signal-card"
            onClick={() => onDestinationClick?.(item)}
            aria-label={`View plans for ${item.destination}`}
          >
            <div
              className="timing-signal-hero"
              style={item.hero_image_url
                ? { background: `url(${item.hero_image_url}) center/cover` }
                : undefined
              }
            >
              {item.trending_tag && (
                <span
                  className="timing-signal-tag"
                  style={item.trending_tag_color ? { background: item.trending_tag_color } : undefined}
                >
                  {item.trending_tag}
                </span>
              )}
            </div>
            <div className="timing-signal-body">
              <p className="timing-signal-dest">{item.destination}</p>
              {item.trending_days_label && (
                <p className="timing-signal-days">
                  <Clock size={11} /> {item.trending_days_label}
                </p>
              )}

            </div>
          </button>
            {item.hero_image_url && item.hero_attribution && (
              <UnsplashCredit
                photographer={item.hero_attribution.photographer}
                profileLink={item.hero_attribution.unsplash_link}
                className="card-photo-credit"
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TimingSignalStrip;
